(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    class NewsletterPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('.newsletter-popup__dialog');
      this.closeButton = this.querySelector('.newsletter-popup__close');
      this.backdrop = this.querySelector('.newsletter-popup__backdrop');
      if (!this.dialog) return;

      this.delay = Number(this.dataset.delay || 2) * 1000;
      this.storageKey = this.dataset.storageKey;
      this.designMode = this.dataset.designMode === 'true';
      this.hasFormState = Boolean(this.querySelector('.newsletter-popup__message'));
      this.handleClose = this.close.bind(this);

      this.closeButton?.addEventListener('click', this.handleClose);
      this.backdrop?.addEventListener('click', this.handleClose);
      this.dialog.addEventListener('close', this.handleClose);

      if (this.hasFormState || this.designMode) {
        this.open();
        return;
      }

      if (this.storageKey && window.localStorage.getItem(this.storageKey) === 'true') {
        return;
      }

      window.setTimeout(() => this.open(), this.delay);
    }

    open() {
      if (!this.dialog.open) {
        this.dialog.showModal();
      }
    }

    close() {
      if (this.dialog.open) {
        this.dialog.close();
        return;
      }

      if (this.storageKey) {
        window.localStorage.setItem(this.storageKey, 'true');
      }
    }
  }

  if (!customElements.get('newsletter-popup')) {
    customElements.define('newsletter-popup', NewsletterPopup);
  }
  } catch(e) { console.error(e); }
})();

})();
